<template>
    <div class="col-md-9 panel panel-default tree-graph-container">
      <tree ref="tree" :data="tree" node-text="name" layoutType="horizontal" :style="styles.renderingArea">
        <template #node="{data, node: {depth}, radius, isRetracted}">
          <template v-if="data.children && data.children.length">
            <path transform="scale(0.05) translate(-10,-250)" :fill="isRetracted? 'red' : 'blue'" d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z">
              <title>{{data.name}}</title>
            </path>
          </template>
          <template v-else>
            <circle r="3" :stroke="zoomable? 'blue' : 'yellow'" :fill="zoomable? 'blue' : 'yellow'">
              <title>{{data.name}}</title>
            </circle>
          </template>
        </template>
      </tree>
    </div>
</template>

<script>
import { tree } from 'vued3tree'
import { TREEDATA } from '../../../treeStaticData'

export default {
  name: 'treeStructure',
  props: ['data', 'title'],
  components: {
    tree
  },
  data: () => {
    return {
      tree: {},
      zoomable: true,
      childs: TREEDATA.children.length,
      styles: {
        renderingArea: {
          width: (window.innerWidth + 200) + 'px',
          height: (window.innerHeight * TREEDATA.children.length) + 'px'
        }
      }
    }
  },

  mounted () {
    this.loadTree()
  },

  methods: {
    loadTree () {
      this.tree = TREEDATA
    }
  }
}
</script>

<style>
  .tree-graph-container {
    display: inline-block;
    overflow-x: auto;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/app/explore/components/TreeStructure.vue